export const REGISTER_URL = "https://k9aud.net/RFESTERSEO";
